import * as types from './constants';

const initialState = {
  data: {},
  deleteLoading: false,
  errors_api: {}
};

const actions = {
  // Delete Assignment
  [types.DELETE_ASSIGNMENT_REQUEST]: state => {
    const data = {
      ...state,
      deleteLoading: true
    };

    return { ...data };
  },

  [types.DELETE_ASSIGNMENT_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      data: payload,
      deleteLoading: false
    };

    return { ...data };
  },

  [types.DELETE_ASSIGNMENT_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      deleteLoading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};